import axios from "axios";
import { useCallback, useEffect, useReducer, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { profileReducer } from "../../functions/reducers";
import Header from "../../components/header";
import "./style.css";
import "./editorialStyles.css";
import Cover from "./Cover";
import ProfielPictureInfos from "./ProfielPictureInfos";
import ProfileMenu from "./ProfileMenu";
import PplYouMayKnow from "./PplYouMayKnow";
import CreatePost from "../../components/createPost";
import GridPosts from "./GridPosts";
import Post from "../../components/post";
import PhotoAlbums from "./PhotoAlbums";
import Friends from "./Friends";
import MutualFriends from "./MutualFriends";
import Intro from "../../components/intro";
import { useMediaQuery } from "react-responsive";
import CreatePostPopup from "../../components/createPostPopup";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { HashLoader } from "react-spinners";
import { getMutualFriends } from "../../functions/user";
import ProfileEditorialTabs from "./ProfileEditorialTabs";

export default function Profile({ getAllPosts }) {
  const [visible, setVisible] = useState(false);
  const { username } = useParams();
  const navigate = useNavigate();
  const { user } = useSelector((state) => ({ ...state }));
  const [photos, setPhotos] = useState({});
  const [mutualFriends, setMutualFriends] = useState({ count: 0, friends: [] });
  const [selectedEditorialType, setSelectedEditorialType] = useState("tudo");
  const [profileFeedPosts, setProfileFeedPosts] = useState([]);
  const [profileFeedLoading, setProfileFeedLoading] = useState(false);
  const [profileFeedPage, setProfileFeedPage] = useState(1);
  const [profileFeedHasMore, setProfileFeedHasMore] = useState(true);
  const [useProfileFeedAPI, setUseProfileFeedAPI] = useState(true); // Flag para usar nova API
  
  var userName = username === undefined ? user.username : username;

  const [{ loading, profile }, dispatch] = useReducer(profileReducer, {
    loading: false,
    profile: {},
    error: "",
  });
  
  useEffect(() => {
    getProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName]);
  
  useEffect(() => {
    setOthername(profile?.details?.otherName);
  }, [profile]);

  var visitor = userName === user.username ? false : true;
  const [othername, setOthername] = useState();
  const path = `${userName}/*`;
  const max = 30;
  const sort = "desc";

  const getProfile = async () => {
    try {
      dispatch({
        type: "PROFILE_REQUEST",
      });
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/getProfile/${userName}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      if (data.ok === false) {
        navigate("/profile");
      } else {
        try {
          const images = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/listImages`,
            { path, sort, max },
            {
              headers: {
                Authorization: `Bearer ${user.token}`,
              },
            }
          );
          setPhotos(images.data);
        } catch (error) {
          console.log(error);
        }
        dispatch({
          type: "PROFILE_SUCCESS",
          payload: data,
        });

        // Load mutual friends if visiting another profile
        if (data._id && data._id !== user.id) {
          const mutualRes = await getMutualFriends(data._id, user.token);
          if (mutualRes.status === "ok") {
            setMutualFriends(mutualRes.data);
          }
        }

        // Carregar posts usando nova API
        setUseProfileFeedAPI(true);
        loadProfileFeed(data._id, "tudo", 1);
      }
    } catch (error) {
      dispatch({
        type: "PROFILE_ERROR",
        payload: error.response.data.message,
      });
    }
  };

  /**
   * Carregar posts do perfil usando nova API
   */
  const loadProfileFeed = async (userId, type = "tudo", page = 1) => {
    try {
      setProfileFeedLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/editorial/profile-feed/${userId}`,
        {
          params: {
            type: type,
            page: page,
            limit: 10,
            sort: "desc",
          },
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      if (data.status === "success") {
        // Se é primeira página, substituir posts; senão, adicionar
        if (page === 1) {
          setProfileFeedPosts(data.data.posts);
        } else {
          setProfileFeedPosts((prev) => [...prev, ...data.data.posts]);
        }
        
        setProfileFeedPage(page);
        setProfileFeedHasMore(data.data.hasMore);
      }
    } catch (error) {
      console.error("Erro ao carregar feed do perfil:", error);
      // Fallback para posts do perfil antigo se a nova API falhar
      setUseProfileFeedAPI(false);
    } finally {
      setProfileFeedLoading(false);
    }
  };

  /**
   * Mudar tipo editorial e recarregar posts
   */
  const handleTypeChange = (newType) => {
    setSelectedEditorialType(newType);
    setProfileFeedPage(1);
    setProfileFeedPosts([]);
    setUseProfileFeedAPI(true); // Garantir que use a nova API
    if (profile._id) {
      loadProfileFeed(profile._id, newType, 1);
    }
  };

  /**
   * Carregar mais posts (infinite scroll)
   */
  const loadMoreProfileFeed = () => {
    if (!profileFeedLoading && profileFeedHasMore && profile._id) {
      loadProfileFeed(profile._id, selectedEditorialType, profileFeedPage + 1);
    }
  };
  
  const profileTop = useRef(null);
  const leftSide = useRef(null);
  const [height, setHeight] = useState();
  const [leftHeight, setLeftHeight] = useState();
  const [scrollHeight, setScrollHeight] = useState();
  useEffect(() => {
    setHeight(profileTop.current.clientHeight + 300);
    setLeftHeight(leftSide.current.clientHeight);
    window.addEventListener("scroll", getScroll, { passive: true });
    return () => {
      window.addEventListener("scroll", getScroll, { passive: true });
    };
  }, [loading, scrollHeight]);
  const check = useMediaQuery({
    query: "(min-width:901px)",
  });
  const getScroll = () => {
    setScrollHeight(window.pageYOffset);
  };

  // Callback para adicionar novo post compartilhado
  const handleShare = useCallback(
    (newSharedPost) => {
      dispatch({
        type: "PROFILE_POSTS",
        payload: [newSharedPost, ...(profile?.posts || [])],
      });
      // Também adicionar ao feed perfil se usando nova API
      if (useProfileFeedAPI) {
        setProfileFeedPosts([newSharedPost, ...profileFeedPosts]);
      }
    },
    [dispatch, profile?.posts, useProfileFeedAPI, profileFeedPosts]
  );

  // Decidir qual posts usar (nova API ou fallback)
  const postsToDisplay = useProfileFeedAPI ? profileFeedPosts : (profile?.posts || []);

  // Filter posts by editorial type (fallback para posts antigos se não usar nova API)
  const filteredPosts = useProfileFeedAPI
    ? postsToDisplay
    : (profile?.posts?.filter((post) => {
        if (selectedEditorialType === "tudo") return true;
        const postType = post.editorialType || "facebook";
        return postType === selectedEditorialType;
      }) || []);

  return (
    <div className="profile">
      {visible && (
        <CreatePostPopup
          user={user}
          setVisible={setVisible}
          posts={profile?.posts}
          dispatch={dispatch}
          profile
        />
      )}
      <Header page="profile" getAllPosts={getAllPosts} />
      <div className="profile_top" ref={profileTop}>
        <div className="profile_container">
          {loading ? (
            <>
              <div className="profile_cover">
                <Skeleton
                  height="347px"
                  containerClassName="avatar-skeleton"
                  style={{ borderRadius: "8px" }}
                />
              </div>
              <div
                className="profile_img_wrap"
                style={{
                  marginBottom: "-3rem",
                  transform: "translateY(-8px)",
                }}
              >
                <div className="profile_w_left">
                  <Skeleton
                    circle
                    height="180px"
                    width="180px"
                    containerClassName="avatar-skeleton"
                    style={{ transform: "translateY(-3.3rem)" }}
                  />
                  <div className="profile_w_col">
                    <div className="profile_name">
                      <Skeleton
                        height="35px"
                        width="200px"
                        containerClassName="avatar-skeleton"
                      />
                      <Skeleton
                        height="30px"
                        width="100px"
                        containerClassName="avatar-skeleton"
                        style={{ transform: "translateY(2.5px)" }}
                      />
                    </div>
                    <div className="profile_friend_count">
                      <Skeleton
                        height="20px"
                        width="90px"
                        containerClassName="avatar-skeleton"
                        style={{ marginTop: "5px" }}
                      />
                    </div>
                    <div className="profile_friend_imgs">
                      {Array.from(new Array(6), (val, i) => i + 1).map(
                        (id, i) => (
                          <Skeleton
                              key={`skeleton-friend-${i}`}
                            circle
                            height="32px"
                            width="32px"
                            containerClassName="avatar-skeleton"
                            style={{ transform: `translateX(${-i * 7}px)` }}
                          />
                        )
                      )}
                    </div>
                  </div>
                </div>
                <div className={`friendship ${!visitor && "fix"}`}>
                  <Skeleton
                    height="36px"
                    width={120}
                    containerClassName="avatar-skeleton"
                  />
                  <div className="flex">
                    <Skeleton
                      height="36px"
                      width={120}
                      containerClassName="avatar-skeleton"
                    />
                    {visitor && (
                      <Skeleton
                        height="36px"
                        width={120}
                        containerClassName="avatar-skeleton"
                      />
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <Cover
                cover={profile.cover}
                visitor={visitor}
                photos={photos.resources}
              />
              <ProfielPictureInfos
                profile={profile}
                visitor={visitor}
                photos={photos.resources}
                othername={othername}
                loading={loading}
              />
            </>
          )}

          <ProfileMenu />
        </div>
      </div>
      <div className="profile_bottom">
        <div className="profile_container">
          <div className="bottom_container">
            <PplYouMayKnow />
            <div
              className={`profile_grid ${
                check && scrollHeight >= height && leftHeight > 1000
                  ? "scrollFixed showLess"
                  : check &&
                    scrollHeight >= height &&
                    leftHeight < 1000 &&
                    "scrollFixed showMore"
              }`}
            >
              <div className="profile_left" ref={leftSide}>
                {loading ? (
                  <>
                    <div className="profile_card">
                      <div className="profile_card_header">Intro</div>
                      <div className="sekelton_loader">
                        <HashLoader color="#1876f2" />
                      </div>
                    </div>
                    <div className="profile_card">
                      <div className="profile_card_header">
                        Fotos
                        <div className="profile_header_link">
                          Ver todas as fotos
                        </div>
                      </div>
                      <div className="sekelton_loader">
                        <HashLoader color="#1876f2" />
                      </div>
                    </div>
                    <div className="profile_card">
                      <div className="profile_card_header">
                        Amigos
                        <div className="profile_header_link">
                          Ver todos os amigos
                        </div>
                      </div>
                      <div className="sekelton_loader">
                        <HashLoader color="#1876f2" />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <Intro
                      detailss={profile.details}
                      visitor={visitor}
                      setOthername={setOthername}
                      profile={profile}
                    />
                    <PhotoAlbums
                      username={userName}
                      token={user.token}
                      photos={photos}
                      profile={profile}
                    />
                    {visitor && mutualFriends.count > 0 && (
                      <MutualFriends mutualFriends={mutualFriends} />
                    )}
                    <Friends friends={profile.friends} />
                  </>
                )}
                <div className="relative_fb_copyright">
                  <Link to="/">Privacy </Link>
                  <span>. </span>
                  <Link to="/">Terms </Link>
                  <span>. </span>
                  <Link to="/">Advertising </Link>
                  <span>. </span>
                  <Link to="/">
                    Ad Choices <i className="ad_choices_icon"></i>{" "}
                  </Link>
                  <span>. </span>
                  <Link to="/"></Link>Cookies <span>. </span>
                  <Link to="/">More </Link>
                  <span>. </span> <br />
                  Meta © 2022
                </div>
              </div>
              <div className="profile_right">
                {!visitor && (
                  <CreatePost user={user} profile setVisible={setVisible} />
                )}
                <GridPosts />
                {/* Editorial Tabs */}
                {!loading && (
                  <ProfileEditorialTabs
                    userId={profile._id}
                    selectedType={selectedEditorialType}
                    onTypeChange={handleTypeChange}
                    posts={profileFeedPosts.length > 0 ? profileFeedPosts : profile.posts}
                    profileUser={profile}
                  />
                )}
                
                {/* Seção de Posts Filtrados */}
                {loading || profileFeedLoading ? (
                  <div className="sekelton_loader">
                    <HashLoader color="#1876f2" />
                  </div>
                ) : (
                  <div className={`posts editorial-type-${selectedEditorialType}`}>
                    {filteredPosts.length > 0 ? (
                      <>
                        {filteredPosts.map((post) => (
                          <Post
                            post={post}
                            user={user}
                            key={post._id}
                            profile
                            onShare={handleShare}
                          />
                        ))}
                        {/* Infinite Scroll Trigger */}
                        {profileFeedHasMore && useProfileFeedAPI && (
                          <div 
                            className="infinite_scroll_trigger"
                            onClick={loadMoreProfileFeed}
                            style={{
                              textAlign: "center",
                              padding: "20px",
                              cursor: "pointer",
                              color: "#1877f2",
                              fontWeight: "500",
                            }}
                          >
                            Carregar mais publicações
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="no_posts">
                        {selectedEditorialType === "tudo"
                          ? "Sem publicações disponíveis"
                          : "Sem publicações nesta categoria"}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
